































	import {Prop, Watch} from "vue-property-decorator";
	import {Stored} from 'vue-stored-prop-decorator';
	import {Component, Vue} from '@/shared/component';
	import {Timeout, WatchObjectProperties} from '@/shared/decorator';

	import storeClient, {ClientFilter} from '@/stores/modules/client';

	import InputDateFilter from '@/components/Input/DateFilter.vue';

	@Component({
		components: {
			InputDateFilter,
		}
	})
	export default class CrudClientFilter extends Vue {

		@Prop({ type: Boolean, default: false}) reduce!: boolean;

		@Stored(() => storeClient) private page!: number;
		@Stored(() => storeClient) private filters!: ClientFilter;

		@WatchObjectProperties('filters', ClientFilter)
		@Timeout()
		private filtersWatcher(): void {
			this.page = 0;
			storeClient.dispatch('getC', { filters: true });
		}
		
		public mounted() {
		    this.typeWatcher();
		}

	    @Watch('type')
		private typeWatcher(): void {
            this.filters.clear();

		}
		
	}
